module.exports = __webpack_public_path__ + "static/img/solutionImg.332c8fd7.png";